<template>
  <div>
    <t-form labelWidth="100px">
      <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
      <t-form-item label="图标">
        <div @click="showGallery" style="width: 168px; height: 160px">
          <t-image style="width: 100%; height: 100%"
                   :src="attribute.icon.url ? fileUrl + attribute.icon.url:require('@/assets/custom/iconRing/info.png')" fit="fill"/>
        </div>
      </t-form-item>
      <t-form-item label="图标边距">
        <t-input-number :min="0" :max="100" v-model="attribute.icon.padding" size="small" :decimal-places="0"/>
      </t-form-item>
      <e-collapse title="标题" :expand="true">
        <t-form-item label="文本">
          <t-input size="small" v-model="attribute.title.text" :maxcharacter="52"/>
        </t-form-item>
        <t-form-item label="字体大小">
          <t-input-number :min="12" :max="100" v-model="attribute.title.fontSize" size="small" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.title.color" size="small"/>
        </t-form-item>
        <t-form-item label="加粗">
          <t-radio-group v-model="attribute.title.fontWeight" size="small">
            <t-radio-button value="lighter">更细</t-radio-button>
            <t-radio-button value="normal">正常</t-radio-button>
            <t-radio-button value="bold">加粗</t-radio-button>
          </t-radio-group>
        </t-form-item>
      </e-collapse>
      <e-collapse title="数值" :expand="true">
        <t-form-item label="字体大小">
          <t-input-number :min="12" :max="100" v-model="attribute.num.fontSize" size="small" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.num.color" size="small"/>
        </t-form-item>
        <t-form-item label="字体">
          <t-select v-model="attribute.num.fontFamily" size="small">
            <t-option v-for="item in textFamilyList" :key="item.value" :label="item.label" :value="item.value"/>
          </t-select>
        </t-form-item>
        <t-form-item label="单位">
          <t-input size="small" v-model="attribute.num.unit" :maxcharacter="12"/>
        </t-form-item>
        <t-form-item label="加粗">
          <t-radio-group v-model="attribute.num.fontWeight" size="small">
            <t-radio-button value="lighter">更细</t-radio-button>
            <t-radio-button value="normal">正常</t-radio-button>
            <t-radio-button value="bold">加粗</t-radio-button>
          </t-radio-group>
        </t-form-item>
      </e-collapse>
      <e-collapse title="增长" :expand="true">
        <t-form-item label="显示">
          <t-switch v-model="attribute.grow.show" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="标签">
          <t-input size="small" v-model="attribute.grow.label" :maxcharacter="12"/>
        </t-form-item>
        <t-form-item label="字体大小">
          <t-input-number :min="12" :max="100" v-model="attribute.grow.fontSize" size="small" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.grow.color" size="small"/>
        </t-form-item>
        <t-form-item label="字体">
          <t-select v-model="attribute.grow.fontFamily" size="small">
            <t-option v-for="item in textFamilyList" :key="item.value" :label="item.label" :value="item.value"/>
          </t-select>
        </t-form-item>
      </e-collapse>
    </t-form>
    <gallery ref="gallery" @confirmCheck="confirmCheck"/>
  </div>
</template>

<script>
import Gallery from "@/components/designer/gallery";
import {fileUrl} from "/env";
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-indicator-option",
  components: {Gallery,CptData},
  props: ['attribute','cptDataForm','currentCpt'],
  data(){
    return {
      fileUrl,
      textFamilyList:[]
    }
  },
  created() {
    this.textFamilyList = require('@/assets/font/font-list')
  },
  methods: {
    showGallery() {
      this.$refs.gallery.opened();
    },
    confirmCheck(fileUrl){
      this.attribute.icon.url = fileUrl;
    }
  }
}
</script>

<style scoped>

</style>
